import cx from "classnames";
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import moment from "moment";
import { isPast } from "date-fns";

import styles from "./styles.module.scss";

interface DueDatePopoverProps {
  dealRoomId: string;
  stageId: string;
  actionId: string;
  isNewAction: boolean;
  dueDate: string;
  disabled: boolean;
  canEditAction: boolean;
  isActionCompleted: boolean;
  onDueDateChange: (dueDate: string) => void;
  onPopoverClose?: () => void;
}

const getButtonText = (dueDate: string) => {
  if (dueDate) {
    return dateFormat(dueDate, "dd mmm yyyy");
  }

  return "Due Date";
};

const DueDatePopover = ({
  dueDate,
  disabled,
  canEditAction,
  isActionCompleted,
  onDueDateChange,
  onPopoverClose,
}: DueDatePopoverProps) => {
  const buttonText = getButtonText(dueDate);
  const isOverdue = dueDate ? isPast(dueDate) : false;

  const handleDueDateChange = (newDate: Date | null) => {
    const newDueDateISO = moment(newDate)
      .local()
      .endOf("day")
      .toISOString(true);

    onDueDateChange(newDueDateISO);
  };

  return (
    <span className={styles.datePickerContainer}>
      <DatePicker
        minDate={moment().subtract(2, "years").toDate()}
        maxDate={moment().add(2, "years").toDate()}
        popperClassName={cx(styles.calendar)}
        customInput={
          <div
            className={cx(styles.actionButton, {
              [styles.overdue]: isOverdue,
              [styles.disabled]:
                !canEditAction ||
                isActionCompleted
            })}
          >
            <i className={cx(styles.icon, "paperflite-calendar")} />
            <p className={styles.buttonText}>{buttonText}</p>
          </div>
        }
        dateFormat="dd MMM yyyy"
        value={dueDate ? moment(dueDate).format("DD MMM YYYY") : "Pick a date"}
        onChange={handleDueDateChange}
        onCalendarClose={onPopoverClose}
        selected={dueDate ? moment(dueDate).toDate() : null}
        showYearDropdown
        yearDropdownItemNumber={15}
        disabled={
          disabled ||
          isActionCompleted
        }
        scrollableYearDropdown
        popperPlacement={"left"}
        portalId={"root-portal"}
      />
    </span>
  );
};

export default DueDatePopover;
